import styled from 'styled-components';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { BRAND_COLORS } from 'brand-guidelines/colors';

export const RequestAppointmentViewWrapper = styled.div`
  border: 1px solid ${BRAND_COLORS.lightGreen};
  border-radius: 8px;
  overflow: hidden;
`;

export const Title = styled.div`
  ${TYPOGRAPHY.OPEN_SANS.semiBold};
  font-size: 14px;
  line-height: 27px;
  background: ${BRAND_COLORS.ashGreen};
  border-bottom: 1px solid ${BRAND_COLORS.lightGreen};
  color: ${BRAND_COLORS.lightGreen};
  text-align: center;
  padding: 6px 0;
`;
